module.exports = __webpack_public_path__ + "static/media/btn_apple_es.b2cb42a5.png";